export default "__VITE_ASSET__DrWnILeL__"